import { Box } from "arkh";
import { graphql, useFragment } from "react-relay";
import { WorkspaceSignalDescription_signalWorkspace$key } from "./__generated__/WorkspaceSignalDescription_signalWorkspace.graphql";
import React from "react";

import { LinkedContent } from "../../../../components/LinkedContent/LinkedContent";

import { useOpenFile } from "../../../Files/useOpenFile";
import { RichTextViewer } from "@/src/components/RichText";

export function WorkspaceSignalDescription(props: {
  signalWorkspace: WorkspaceSignalDescription_signalWorkspace$key;
}) {
  const signalWorkspace = useFragment(
    graphql`
      fragment WorkspaceSignalDescription_signalWorkspace on SignalWorkspace {
        body
        formattedBody
        body
        descriptionImages {
          ...LinkedContent_images
        }
        descriptionFiles {
          ...LinkedContent_files
        }
      }
    `,
    props.signalWorkspace
  );

  const openFile = useOpenFile();
  return (
    <Box spaceBottom="large">
      <Box style={{ maxWidth: 600 }} spaceHorizontal="medium">
        <RichTextViewer
          data={signalWorkspace.formattedBody}
          unformattedData={signalWorkspace.body}
        />
      </Box>
      <LinkedContent
        files={signalWorkspace.descriptionFiles}
        images={signalWorkspace.descriptionImages}
        openFile={openFile}
        borderColor="border-strong"
      />
    </Box>
  );
}
